import { render, staticRenderFns } from "./simplifyHisFee.vue?vue&type=template&id=3dc40728&scoped=true"
import script from "./simplifyHisFee.vue?vue&type=script&lang=js"
export * from "./simplifyHisFee.vue?vue&type=script&lang=js"
import style0 from "./simplifyHisFee.vue?vue&type=style&index=0&id=3dc40728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc40728",
  null
  
)

export default component.exports